export default __webpack_public_path__ + "static/media/CFA_Symbol.dabf0872.svg";